/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Dashboard 2 React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Dashboard 2 React using thie file.
 */

const colors = {
  // Midnight navy surfaces, each layer one step lighter.
  background: {
    default: "#0a0f1c",
    sidenav: "#0d1324",
    card: "#131a2c",
    paper: "#131a2c",
    elevated: "#1a2338",
  },

  text: {
    main: "#e6ebf5",
    focus: "#ffffff",
    muted: "#8e9ab3",
    disabled: "#5b6782",
  },

  divider: "rgba(148, 163, 184, 0.14)",

  // Same token names as the light theme, tuned for dark surfaces.
  ink: {
    strong: "#f1f5ff",
    main: "#e6ebf5",
    body: "#cfd8e8",
    soft: "#a3b0c8",
  },

  line: {
    main: "rgba(148, 163, 184, 0.16)",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#4c8dff",
    focus: "#6ea3ff",
  },

  secondary: {
    main: "#64748b",
    focus: "#94a3b8",
  },

  info: {
    main: "#4c8dff",
    focus: "#6ea3ff",
  },

  success: {
    main: "#34d399",
    focus: "#6ee7b7",
  },

  warning: {
    main: "#fbbf24",
    focus: "#fcd34d",
  },

  error: {
    main: "#f87171",
    focus: "#fca5a5",
  },

  light: {
    main: "#f0f2f566",
    focus: "#f0f2f566",
  },

  dark: {
    main: "#344767",
    focus: "#2c3c58",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#EC407A",
      state: "#D81B60",
    },

    secondary: {
      main: "#747b8a",
      state: "#495361",
    },

    info: {
      main: "#4c8dff",
      state: "#0061fe",
    },

    success: {
      main: "#34d399",
      state: "#059669",
    },

    warning: {
      main: "#fbbf24",
      state: "#d97706",
    },

    error: {
      main: "#f87171",
      state: "#dc2626",
    },

    light: {
      main: "#2a3550",
      state: "#1f2940",
    },

    dark: {
      main: "#1f2940",
      state: "#131a2c",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: { background: "rgba(76, 141, 255, 0.16)", text: "#8db6ff" },
    secondary: { background: "rgba(148, 163, 184, 0.16)", text: "#cbd5e1" },
    info: { background: "rgba(76, 141, 255, 0.16)", text: "#8db6ff" },
    success: { background: "rgba(52, 211, 153, 0.16)", text: "#6ee7b7" },
    warning: { background: "rgba(251, 191, 36, 0.16)", text: "#fcd34d" },
    error: { background: "rgba(248, 113, 113, 0.16)", text: "#fca5a5" },
    light: { background: "rgba(255, 255, 255, 0.08)", text: "#e6ebf5" },
    dark: { background: "rgba(148, 163, 184, 0.12)", text: "#e6ebf5" },
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "rgba(148, 163, 184, 0.28)",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
